import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// UI-P1: chart-type trigger + portal menu tach tu OHLCHeader (fat-file).
// OHLCHeader GIU TOAN BO state/refs (menuPos machine, click-outside); file nay thuan presentational.
import { createPortal } from "react-dom";
import { useEffect, useRef, useState } from "react";
import { CHART_TYPE_OPTIONS, isChartTypeComingSoon, isChartTypeLocked, } from "../../utils/chartTypeOptions";
import styles from "../../styles/ohlc-header.module.css";
function getChartTypeLabel(chartType, t) {
    const opt = CHART_TYPE_OPTIONS.find(ct => ct.value === chartType);
    if (!opt)
        return chartType;
    return t(opt.labelKey);
}
export function ChartTypeMenu({ open, menuPos, dropdownRef, btnRef, menuRef, portalRoot, chartType = "candlestick", patTier, upgradeUrl, onToggle, onSelect, t, }) {
    const [lockedPopover, setLockedPopover] = useState(null);
    const popoverRef = useRef(null);
    /* eslint-disable no-restricted-globals */
    useEffect(() => {
        if (!lockedPopover)
            return;
        const onDown = (e) => {
            if (popoverRef.current && popoverRef.current.contains(e.target))
                return;
            setLockedPopover(null);
        };
        const onKey = (e) => {
            if (e.key === "Escape")
                setLockedPopover(null);
        };
        // Defer attaching mousedown so the opening click doesn't immediately close.
        const timer = window.setTimeout(() => {
            document.addEventListener("mousedown", onDown);
        }, 0);
        document.addEventListener("keydown", onKey);
        return () => {
            window.clearTimeout(timer);
            document.removeEventListener("mousedown", onDown);
            document.removeEventListener("keydown", onKey);
        };
    }, [lockedPopover]);
    useEffect(() => {
        if (!open)
            setLockedPopover(null);
    }, [open]);
    /* eslint-enable no-restricted-globals */
    return (_jsxs("div", { className: styles.selectorGroup, ref: dropdownRef, children: [_jsxs("button", { type: "button", ref: btnRef, "data-testid": "chart-type-btn", className: `${styles.selectorBtn} ${open ? styles.selectorBtnOpen : ""}`, onClick: onToggle, "aria-expanded": open, "aria-haspopup": "listbox", title: t("header.chartType"), children: [getChartTypeLabel(chartType, t), _jsx("span", { className: styles.selectorArrow, children: "\u25BC" })] }), open && menuPos && typeof document !== "undefined" && createPortal(_jsx("ul", { ref: menuRef, className: `${styles.dropdown} ${styles.dropdownFloating}`, role: "listbox", "aria-label": t("header.chartTypeOptions"), style: { top: menuPos.top, left: menuPos.left }, children: CHART_TYPE_OPTIONS.map(ct => {
                    // Tier CHUA biet (`patTier` vang) => khoa, theo
                    // `hasCapability(null, …) === false` — fail-closed.
                    const locked = isChartTypeLocked(ct, patTier);
                    const comingSoon = isChartTypeComingSoon(ct);
                    return (_jsxs("li", { role: "option", "data-chart-type": ct.value, "aria-selected": ct.value === chartType, "aria-disabled": locked, title: locked && !comingSoon ? t("tool.premiumLocked") : undefined, style: locked && !comingSoon ? { position: "relative" } : undefined, "data-coming-soon": comingSoon ? ct.value : undefined, "data-locked": locked && !comingSoon ? ct.value : undefined, className: `${styles.dropdownItem} ${ct.value === chartType ? styles.dropdownItemSelected : ""} ${locked ? styles.dropdownItemDisabled : ""}`, onClick: (e) => {
                            e.stopPropagation();
                            if (locked) {
                                if (!comingSoon)
                                    setLockedPopover((prev) => (prev === ct.value ? null : ct.value));
                                return;
                            }
                            setLockedPopover(null);
                            onSelect(ct.value);
                        }, children: [t(ct.labelKey), comingSoon && _jsx("span", { className: styles.comingSoonBadge, children: t("chartType.comingSoon") }), locked && !comingSoon && _jsx("span", { className: styles.comingSoonBadge, children: t("chartType.proLocked") }), locked && !comingSoon && lockedPopover === ct.value && (_jsxs("div", { ref: popoverRef, role: "dialog", "aria-label": t("tool.premiumLocked"), style: {
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    marginTop: 4,
                                    minWidth: 180,
                                    padding: "8px 10px",
                                    background: "var(--vnsc-bg-popover, #1a1f2e)",
                                    border: "1px solid var(--vnsc-border, #2a2e39)",
                                    borderRadius: 6,
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                                    zIndex: 10,
                                    color: "var(--vnsc-text-primary, #d1d4dc)",
                                    fontSize: 12,
                                }, onClick: (e) => e.stopPropagation(), children: [_jsx("div", { style: { fontWeight: 600, marginBottom: 4 }, children: t(ct.labelKey) }), _jsx("div", { style: { opacity: 0.8, marginBottom: 6 }, children: t("tool.premiumLocked") }), upgradeUrl && (_jsx("a", { href: upgradeUrl, target: "_blank", rel: "noopener noreferrer", style: { color: "var(--vnsc-color-accent, #2962ff)", textDecoration: "underline" }, onClick: (e) => e.stopPropagation(), children: t("tool.premiumLocked") }))] }))] }, ct.value));
                }) }), 
            // eslint-disable-next-line no-restricted-globals -- portal fallback: moved verbatim from OHLCHeader (S9 pattern).
            portalRoot ?? document.body)] }));
}
